import * as React from 'react';

import { Button, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import {
  $brokeredOrderForm,
  BrokeredOrderFormState,
} from '../../_state/brokeredOrderForm.state';
import { useTranslations } from '../../i18n/useTranslations';

type Props = {
  isSaving?: boolean;
  onSaveUpdates?: (data?: BrokeredOrderFormState) => void;
  onDiscard?: () => void;
};

export const BrokeredOrderFormFooterActions: React.FC<Props> = ({
  isSaving,
  onSaveUpdates,
  onDiscard,
}) => {
  const t = useTranslations();
  const form = useAtomValue($brokeredOrderForm);

  return (
    <div
      className={cn(
        '@BrokeredOrderFormFooterActions',
        'sticky bottom-0 mt-5 flex flex-0 justify-end gap-3 border-t border-neutral/10 bg-white px-6 pt-5 pb-5',
      )}
    >
      <Button
        color="neutral"
        variant="outline"
        onPress={() => onDiscard?.()}
        isDisabled={isSaving}
      >
        {t.orders.detail.footer.discard}
      </Button>
      <Button
        color="primary"
        variant="solid"
        onPress={() => onSaveUpdates?.(form)}
        isPending={isSaving}
        isLoading={isSaving}
      >
        {t.orders.detail.footer.saveUpdates}
      </Button>
    </div>
  );
};
